<template>
  <div class="modal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Tambah {{ label }}</h4>
          <button type="button" class="btn btn-sm" v-on:click="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="kbli-modal-filter-search" style="padding: 0 10px">
          <form v-on:submit.prevent="noop">
            <div class="input-search">
              <b-input-group>
                <template #append>
                  <b-input-group-text>
                    <strong>
                      <i class="fas fa-times" style="cursor:pointer; marginRight: 10px" @click="resetPlaceholder()"
                        v-if="subSearch.length !== '' && subSearch"></i>
                      <i class="fas fa-search" style="cursor:pointer"></i>
                    </strong>
                  </b-input-group-text>
                </template>
                <b-form-input type="text" placeholder="Cari Usaha" v-model="subSearch"
                  @keyup="searchRun()"></b-form-input>
              </b-input-group>
            </div>
          </form>
        </div>
        <div class="modal-body" v-if="kbliData">
          <div class="horizontal">
            <div class="column5"></div>
            <div class="column10">Kode</div>
            <div class="column30 mr10">Keterangan</div>
          </div>
          <div class="horizontal" v-for="(item, index) in kbli" :key="index">
            <div class="column5">
              <input class="modal-input-checkbox" type="checkbox" :id="index" :value="item.id" v-model="choosedKbli" />
            </div>
            <div class="column10">{{ item.kode }}</div>
            <div class="column90 col-nohover mr10">{{ item.desc }}</div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="submit()">
            Selesai
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['storeName', 'modelName', 'label', 'mutationName', 'modalName'],
  data() {
    return {
      kbli: [],
      subKbliMaster: [],
      choosedKbli: [],
      subSearch: '',
    }
  },
  computed: {
    kbliData: async function () {
      await this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)
      const getKbli = await this.$getKbli()
      const defaultKbli = await this.$store.state[this.storeName][
        this.modelName
      ]

      let reduceKbli = await getKbli.reduce(
        (a, b) => ({ ...a, [b.kode]: b }),
        {}
      )
      let reduceDefault =
        (await defaultKbli) &&
        defaultKbli.reduce((a, b) => ({ ...a, [b.kode]: b }), {})
      let combine = { ...reduceKbli, ...reduceDefault }

      let newKbli = await Object.values(combine)

      this.kbli = newKbli.sort((a, b) => this.$sortAsc(a, b))
      this.subKbliMaster = newKbli.sort((a, b) => this.$sortAsc(a, b))
      this.choosedKbli = await defaultKbli.map(list => {
        return list.id
      })

      await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
    },
  },
  methods: {
    async searchRun(id) {
      const self = this
      const search = String(self.subSearch)
      const list = self.subKbliMaster

      let filteredList = []
      for (let i in list) {
        if (list[i].desc.toLowerCase().indexOf(search.toLowerCase()) != -1) {
          filteredList.push(list[i])
        }
      }

      this.kbli = filteredList
    },
    resetPlaceholder() {
      this.subSearch = ''
      // this.subKbli = this.subKbliMaster
      this.searchRun()
    },
    async inputKbli() {
      const newItems = this.kbli.filter(i => this.choosedKbli.includes(i.id))
      this.closeModal()
      await this.$store.commit(this.mutationName, {
        name: this.modelName,
        value: newItems,
      })
    },
    async submit() {
      await this.resetPlaceholder()
      await this.inputKbli()
      await this.closeModal()
    },
    closeModal() {
      this.$store.commit(this.mutationName, {
        name: this.modalName,
        value: false,
      })
    },
  },
}
</script>
<style scoped>
.modal {
  width: 100vw;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-dialog {
  width: 100vw;
  height: 100%;
}

.modal-content {
  width: 50vw;
  position: absolute;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -30%);
}

.modal-body {
  height: 50vh;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.modal-input-checkbox {
  margin-right: 20px;
}
</style>
